import React from 'react'
import _ from 'lodash/fp'

import unsafeValidator from 'validator'

import { getStaticBackground } from '../../config'
import images from '../../images'
import colors from '@fe/ui/colors'

import { ErrorMessage } from 'formik'
import moment from 'moment'

// Material UI things
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import MUIChip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core'

// Validator throws on everything but strings, so map all params to string and wrap all calls in a try-catch
export const validator = new Proxy(unsafeValidator, {
  get: (target, key) => {
    const f = _.get(key, target)
    if (_.isFunction(f)) {
      return (...params) => {
        const stringParams = _.map(_.toString, params)
        try {
          return f(...stringParams)
        } catch (_err) {
          console.log(_err)
          return false
        }
      }
    }
    return f
  }
})

const styles = (theme) => ({
  widthCalc: {
    width: '100vw',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100vw - 240px)'
    }
  },
  fullWidth: {
    width: '100vw'
  },
  chip: {
    margin: theme.spacing(1),
    width: 200,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  glfrlogo: {
    backgroundColor: colors.white,
    width: 100,
    height: 100,
    borderRadius: '50%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    marginTop: 12
  }
})

class AuthPanelBase extends React.Component {
  render () {
    const backgroundStyles = this.props.noBackground
      ? {}
      : {
          backgroundImage: `url(${this.props.backgroundImage || getStaticBackground()})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        }
    return (
      <div
        className={this.props.routed ? this.props.classes.widthCalc : this.props.classes.fullWidth}
        style={{
          position: 'fixed',
          height: `calc(100vh - ${this.props.routed ? 64 : 0}px)`,
          overflowY: 'scroll',
          ...backgroundStyles
        }}
      >
        <Grid container>
          <Hidden smDown>
            <Grid style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} item md={6} onClick={this.props.handleLeftBoxClick} />
          </Hidden>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={10}
              style={{
                minHeight: `calc(100vh - ${this.props.routed ? 64 : 0}px)`
              }}
              square
            >
              <div style={{ position: 'relative' }}>
                {this.props.action && (
                  <div style={{
                    position: 'absolute',
                    [`${this.props.align || 'left'}`]: 0
                  }}
                  >
                    {this.props.action}
                  </div>
                )}
              </div>
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center'
                }}
              >
                {this.props.header && _.isString(this.props.header)
                  ? (
                    <Typography
                      align='center'
                      style={{ paddingTop: '32px' }}
                      variant='h3'
                    >{this.props.header}
                    </Typography>
                    )
                  : this.props.header}
                {this.props.children}
                <div
                  className={this.props.classes.glfrlogo}
                  style={{ backgroundImage: `url(${images.icons.glfrLogo})` }}
                />
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}
export const AuthPanel = _.compose(
  withStyles(styles)
)(AuthPanelBase)

class ButtonChipBase extends React.Component {
  render () {
    return (
      <MUIChip
        {..._.omit('classes', this.props)}
        className={this.props.classes.chip}
        component='button'
        type='submit'
        variant='outlined'
      />
    )
  }
}

export const Chip = _.compose(
  withStyles(styles)
)(ButtonChipBase)

export const InputField = ({ field, form: { touched, errors }, inputType, label, ...props }) => {
  const HelperText = <ErrorMessage name={field.name} />
  return (
    <TextField
      style={{ margin: '0.5em 0' }}
      {...field}
      {...props}
      required
      fullWidth
      type={inputType}
      label={label}
      error={touched[field.name] && Boolean(errors[field.name])}
      helperText={HelperText}
    />
  )
}

export const isRequired = (v) => _.isEmpty(v) && 'Required'
export const validateEmail = (v) => !validator.isEmail(v) && 'Invalid email'
export const validateDate = (v) => {
  return moment(v, 'YY-MM-DD').isValid()
}
export const validateBirthday = (v) => {
  const isDate = validateDate(v)
  // TODO: we can probably reject births from the 19th century and the future
  return !isDate && 'Invalid birthday'
}
export const validatePasswordConfirm = (password) => (passwordConfirm) => password && passwordConfirm && (password !== passwordConfirm && 'Passwords do not match')

export const validate = fields => {
  const errors = _.reduce((errors, key) => {
    const { value, validators } = fields[key]
    const e = _.flow(
      _.map(f => f(value)),
      _.compact
    )(validators)
    if (_.isEmpty(e)) {
      return errors
    }
    return ({ ...errors, [key]: e[0] })
  }, {}, _.keys(fields))
  return errors
}
